/* Nice Select 2 Js */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.NiceSelect=t():e.NiceSelect=t()}(self,(()=>(()=>{"use strict";var e={d:(t,i)=>{for(var s in i)e.o(i,s)&&!e.o(t,s)&&Object.defineProperty(t,s,{enumerable:!0,get:i[s]})},o:(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r:e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})}},t={};function i(e){var t=document.createEvent("MouseEvents");t.initEvent("click",!0,!1),e.dispatchEvent(t)}function s(e){var t=document.createEvent("HTMLEvents");t.initEvent("change",!0,!1),e.dispatchEvent(t)}function o(e){var t=document.createEvent("FocusEvent");t.initEvent("focusin",!0,!1),e.dispatchEvent(t)}function n(e){var t=document.createEvent("FocusEvent");t.initEvent("focusout",!0,!1),e.dispatchEvent(t)}function d(e){var t=document.createEvent("UIEvent");t.initEvent("modalclose",!0,!1),e.dispatchEvent(t)}function l(e,t){"invalid"==t?(c(this.dropdown,"invalid"),h(this.dropdown,"valid")):(c(this.dropdown,"valid"),h(this.dropdown,"invalid"))}function r(e,t){return null!=e[t]?e[t]:e.getAttribute(t)}function a(e,t){return!!e&&e.classList.contains(t)}function c(e,t){if(e)return e.classList.add(t)}function h(e,t){if(e)return e.classList.remove(t)}e.r(t),e.d(t,{bind:()=>f,default:()=>u});var p={data:null,searchable:!1,showSelectedItems:!1};function u(e,t){this.el=e,this.config=Object.assign({},p,t||{}),this.data=this.config.data,this.selectedOptions=[],this.placeholder=r(this.el,"placeholder")||this.config.placeholder||"Select an option",this.searchtext=r(this.el,"searchtext")||this.config.searchtext||"Search",this.selectedtext=r(this.el,"selectedtext")||this.config.selectedtext||"selected",this.dropdown=null,this.multiple=r(this.el,"multiple"),this.disabled=r(this.el,"disabled"),this.create()}function f(e,t){return new u(e,t)}return u.prototype.create=function(){this.el.style.opacity="0",this.el.style.width="0",this.el.style.padding="0",this.el.style.height="0",this.data?this.processData(this.data):this.extractData(),this.renderDropdown(),this.bindEvent()},u.prototype.processData=function(e){var t=[];e.forEach((e=>{t.push({data:e,attributes:{selected:!!e.selected,disabled:!!e.disabled,optgroup:"optgroup"==e.value}})})),this.options=t},u.prototype.extractData=function(){var e=this.el.querySelectorAll("option,optgroup"),t=[],i=[],s=[];e.forEach((e=>{if("OPTGROUP"==e.tagName)var s={text:e.label,value:"optgroup"};else s={text:e.innerText,value:e.value,selected:null!=e.getAttribute("selected")||this.el.value==e.value,disabled:null!=e.getAttribute("disabled")};var o={selected:e.selected,disabled:e.disabled,optgroup:"OPTGROUP"==e.tagName};t.push(s),i.push({data:s,attributes:o})})),this.data=t,this.options=i,this.options.forEach((e=>{e.attributes.selected&&s.push(e)})),this.selectedOptions=s},u.prototype.renderDropdown=function(){var e=["nice-select",r(this.el,"class")||"",this.disabled?"disabled":"",this.multiple?"has-multiple":""];let t='<div class="nice-select-search-box">';t+=`<input type="text" class="nice-select-search" placeholder="${this.searchtext}..." title="search"/>`,t+="</div>";var i=`<div class="${e.join(" ")}" tabindex="${this.disabled?null:0}">`;i+=`<span class="${this.multiple?"multiple-options":"current"}"></span>`,i+='<div class="nice-select-dropdown">',i+=`${this.config.searchable?t:""}`,i+='<ul class="list"></ul>',i+="</div>",i+="</div>",this.el.insertAdjacentHTML("afterend",i),this.dropdown=this.el.nextElementSibling,this._renderSelectedItems(),this._renderItems()},u.prototype._renderSelectedItems=function(){if(this.multiple){var e="";this.config.showSelectedItems||this.config.showSelectedItems||"auto"==window.getComputedStyle(this.dropdown).width||this.selectedOptions.length<2?(this.selectedOptions.forEach((function(t){e+=`<span class="current">${t.data.text}</span>`})),e=""==e?this.placeholder:e):e=this.selectedOptions.length+" "+this.selectedtext,this.dropdown.querySelector(".multiple-options").innerHTML=e}else{var t=this.selectedOptions.length>0?this.selectedOptions[0].data.text:this.placeholder;this.dropdown.querySelector(".current").innerHTML=t}},u.prototype._renderItems=function(){var e=this.dropdown.querySelector("ul");this.options.forEach((t=>{e.appendChild(this._renderItem(t))}))},u.prototype._renderItem=function(e){var t=document.createElement("li");if(t.innerHTML=e.data.text,e.attributes.optgroup)c(t,"optgroup");else{t.setAttribute("data-value",e.data.value);var i=["option",e.attributes.selected?"selected":null,e.attributes.disabled?"disabled":null];t.addEventListener("click",this._onItemClicked.bind(this,e)),t.classList.add(...i)}return e.element=t,t},u.prototype.update=function(){if(this.extractData(),this.dropdown){var e=a(this.dropdown,"open");this.dropdown.parentNode.removeChild(this.dropdown),this.create(),e&&i(this.dropdown)}r(this.el,"disabled")?this.disable():this.enable()},u.prototype.disable=function(){this.disabled||(this.disabled=!0,c(this.dropdown,"disabled"))},u.prototype.enable=function(){this.disabled&&(this.disabled=!1,h(this.dropdown,"disabled"))},u.prototype.clear=function(){this.resetSelectValue(),this.selectedOptions=[],this._renderSelectedItems(),this.update(),s(this.el)},u.prototype.destroy=function(){this.dropdown&&(this.dropdown.parentNode.removeChild(this.dropdown),this.el.style.display="")},u.prototype.bindEvent=function(){this.dropdown.addEventListener("click",this._onClicked.bind(this)),this.dropdown.addEventListener("keydown",this._onKeyPressed.bind(this)),this.dropdown.addEventListener("focusin",o.bind(this,this.el)),this.dropdown.addEventListener("focusout",n.bind(this,this.el)),this.el.addEventListener("invalid",l.bind(this,this.el,"invalid")),window.addEventListener("click",this._onClickedOutside.bind(this)),this.config.searchable&&this._bindSearchEvent()},u.prototype._bindSearchEvent=function(){var e=this.dropdown.querySelector(".nice-select-search");e&&e.addEventListener("click",(function(e){return e.stopPropagation(),!1})),e.addEventListener("input",this._onSearchChanged.bind(this))},u.prototype._onClicked=function(e){var t,i;if(e.preventDefault(),a(this.dropdown,"open")?this.multiple||(h(this.dropdown,"open"),d(this.el)):(c(this.dropdown,"open"),t=this.el,(i=document.createEvent("UIEvent")).initEvent("modalopen",!0,!1),t.dispatchEvent(i)),a(this.dropdown,"open")){var s=this.dropdown.querySelector(".nice-select-search");s&&(s.value="",s.focus());var o=this.dropdown.querySelector(".focus");h(o,"focus"),c(o=this.dropdown.querySelector(".selected"),"focus"),this.dropdown.querySelectorAll("ul li").forEach((function(e){e.style.display=""}))}else this.dropdown.focus()},u.prototype._onItemClicked=function(e,t){var i=t.target;a(i,"disabled")||(this.multiple?a(i,"selected")?(h(i,"selected"),this.selectedOptions.splice(this.selectedOptions.indexOf(e),1),this.el.querySelector(`option[value="${i.dataset.value}"]`).removeAttribute("selected")):(c(i,"selected"),this.selectedOptions.push(e)):(this.selectedOptions.forEach((function(e){h(e.element,"selected")})),c(i,"selected"),this.selectedOptions=[e]),this._renderSelectedItems(),this.updateSelectValue())},u.prototype.updateSelectValue=function(){if(this.multiple){var e=this.el;this.selectedOptions.forEach((function(t){var i=e.querySelector(`option[value="${t.data.value}"]`);i&&i.setAttribute("selected",!0)}))}else this.selectedOptions.length>0&&(this.el.value=this.selectedOptions[0].data.value);s(this.el)},u.prototype.resetSelectValue=function(){if(this.multiple){var e=this.el;this.selectedOptions.forEach((function(t){var i=e.querySelector(`option[value="${t.data.value}"]`);i&&i.removeAttribute("selected")}))}else this.selectedOptions.length>0&&(this.el.selectedIndex=-1);s(this.el)},u.prototype._onClickedOutside=function(e){this.dropdown.contains(e.target)||(h(this.dropdown,"open"),d(this.el))},u.prototype._onKeyPressed=function(e){var t=this.dropdown.querySelector(".focus"),s=a(this.dropdown,"open");if(13==e.keyCode)i(s?t:this.dropdown);else if(40==e.keyCode){if(s){var o=this._findNext(t);o&&(h(this.dropdown.querySelector(".focus"),"focus"),c(o,"focus"),o.scrollIntoView({block:"nearest"}))}else i(this.dropdown);e.preventDefault()}else if(38==e.keyCode){if(s){var n=this._findPrev(t);n&&(h(this.dropdown.querySelector(".focus"),"focus"),c(n,"focus"),n.scrollIntoView({block:"nearest"}))}else i(this.dropdown);e.preventDefault()}else if(27==e.keyCode&&s)i(this.dropdown);else if(32===e.keyCode&&s)return!1;return!1},u.prototype._findNext=function(e){for(e=e?e.nextElementSibling:this.dropdown.querySelector(".list .option");e;){if(!a(e,"disabled")&&"none"!=e.style.display)return e;e=e.nextElementSibling}return null},u.prototype._findPrev=function(e){for(e=e?e.previousElementSibling:this.dropdown.querySelector(".list .option:last-child");e;){if(!a(e,"disabled")&&"none"!=e.style.display)return e;e=e.previousElementSibling}return null},u.prototype._onSearchChanged=function(e){var t=a(this.dropdown,"open"),i=e.target.value;if(""==(i=i.toLowerCase()))this.options.forEach((function(e){e.element.style.display=""}));else if(t){var s=new RegExp(i);this.options.forEach((function(e){var t=e.data.text.toLowerCase(),i=s.test(t);e.element.style.display=i?"":"none"}))}this.dropdown.querySelectorAll(".focus").forEach((function(e){h(e,"focus")})),c(this._findNext(null),"focus")},t})()));

/*=========================
    Enavi Sofa Builder JS
==========================*/

theme.EnaviSofaBuilder =(function(){

  const selectors = {
    addToCartBtn: '#AddToCart',
    cylindoViewer: 'cylindo-viewer',
    productSelector: '.product-selector-box',
    productSelectorHeading: '.product-selector-box > .box-heading',
    dropdownAddon: '.enavi-selector_addon',
    dropdownContainer: '.option-dropdown:not(.nice2-dropdown)',
    nice2Dropdown: '.nice-2-dropdown',
    selectionLabel: '.selection-label',
    optionRadio: '.radio-option',
    fabricProduct: '.fabric_product',
    firmnessProduct: '.firmness-btn',
    filterHeading: '.filter-heading',
    fabricContainer: '[data-selector-type="Fabric"] > .box-content',
    fabricFilterOption: '.fabric-filter-option',
    fabricFilterHeading: '.fabric-filter-option > .box-heading',
    filterByPatternDropdown: '#filter-pattern-select',
    applyFilterBtn: '.apply-filter-btn',
    clearFilterBtn: '.clear-filter-btn',
    fabricMaterialModal: '#fabric-material-popup .product-popup-modal__content-info',
    filterBtn: '.filter-btn',
    cushionTypes: '.cushion_option',
    legProducts: '.leg_option',
    selectImage: '.selection-img',
    drawerCloseBtn: '.drawer-close-btn',
    sliderImage: '.product-images__slide .product-single__media img',
    productSlider: 'product-slider'
  };

  function EnaviSofaBuilder(container){
    if(container){
      this.init(container);
    }
  };

  EnaviSofaBuilder.prototype = Object.assign({}, EnaviSofaBuilder.prototype, {
    init: function(container){
      this.container = container;
      this.sectionID = this.container.dataset.sectionId;
      this.addToCart = this.select(selectors.addToCartBtn);
      this.atcPrice  = this.addToCart.querySelector('.atc-price');
      this.productPriceEl  = document.querySelector('.product-price-container .amount');
      this.form      = this.addToCart.closest('form');
      this.cylindoViewer = document.querySelector(selectors.cylindoViewer);
      this.productSelectors = this.selectAll(selectors.productSelector);
      this.productSelectorsHeading = this.selectAll(selectors.productSelectorHeading);
      this.optionRadios = this.selectAll(selectors.optionRadio);
      this.dropdownAddons = this.selectAll(selectors.dropdownAddon);
      this.dropdownContainers = this.selectAll(selectors.dropdownContainer);
      this.nice2Dropdowns = this.selectAll(selectors.nice2Dropdown);
      this.selectImages = this.selectAll(selectors.selectImage);
      this.fabricContainer =  this.select(selectors.fabricContainer);
      this.fabricProducts = this.selectAll(selectors.fabricProduct);
      this.fabricFilterAccordion = this.select(selectors.filterHeading);
      this.fabricFilters = this.selectAll(selectors.fabricFilterOption);
      this.fabricFilterHeadings = this.selectAll(selectors.fabricFilterHeading);
      this.filterByPatternDropdown = this.select(selectors.filterByPatternDropdown);
      this.filterBtns = this.selectAll(selectors.filterBtn);
      this.applyFilterBtn = this.select(selectors.applyFilterBtn);
      this.clearFilterBtn = this.select(selectors.clearFilterBtn);
      this.firmnessProducts = this.selectAll(selectors.firmnessProduct);
      this.cushionTypes = this.selectAll(selectors.cushionTypes);
      this.legProducts = this.selectAll(selectors.legProducts);
      this.drawerCloseBtn = this.selectAll(selectors.drawerCloseBtn);

      this.addToCart.setAttribute("data-disable-atc", "true");
      this.addToCart.type = 'button';
      this.basePrice = parseInt(container.dataset.basePrice);
      this.allItems = [];
      this.requiredAddons = Array.from(this.productSelectors).concat(Array.from(this.dropdownAddons)).filter(function(addon) {
        return addon.classList.contains('required-addon');
      });

      if(this.form){
        this.addToCart.addEventListener('click', this.handleAtc.bind(this));
      }
      this.addEventListeners();

      //Initial selections
      this.handleDropdownChange(this.dropdownAddons);

      // Add Cylindo viewer initialization
      if(this.cylindoViewer) {
        this.cylindoViewer.addEventListener("loaded", () => {
          this.handleCylindoDefaultFeatures();
        });
      }

    },

    select: function(selector){
      return this.container.querySelector(selector);
    },

    selectAll: function(selector){
      return Array.prototype.slice.apply(this.container.querySelectorAll(selector));
    },

    addEventListeners: function(){
      // Initiate product accordions
      this.productSelectors.forEach(selector => {
        this.initAccordion(selector, this.productSelectorsHeading);
      });

      this.initAccordion(this.fabricFilterAccordion.parentElement);

      this.initCustomSelectDropdowns();

      this.initNice2Dropdowns();
      
      document.addEventListener("click", this.closeAllSelect());


      if(this.cylindoViewer){
        this.cylindoViewer.addEventListener("error", event => {
          const errorMessage = event.detail.error?.message;
          if(!errorMessage){
            return;
          }
          const errorDiv = document.createElement('div');
          errorDiv.className = 'cylindo-error-message';
          
          // Parse the error message to determine which feature failed
          let userMessage = "Preview Not Available for selected features";
          
          if (errorMessage.includes('LEG TYPE')) {
            userMessage = "Preview Not Available for selected Leg Type";
            // Remove leg type from features
            if (this.cylindoViewer.features) {
              const { ['LEG TYPE']: removedLeg, ...remainingFeatures } = this.cylindoViewer.features;
              this.cylindoViewer.features = remainingFeatures;
            }
          } else if (errorMessage.includes('UPHOLSTERY')) {
            userMessage = "Preview Not Available for selected Fabric";
          }
          
          errorDiv.textContent = userMessage;
          
          // Remove any existing error message
          const existingError = document.querySelector('.cylindo-error-message');
          if (existingError) {
            existingError.remove();
          }
          
          // Insert the new error message before the cylindo-viewer
          this.cylindoViewer.parentNode.insertBefore(errorDiv, this.cylindoViewer);
        });
      }

      // Add event listener for radio option change
      this.optionRadios.forEach(option => {
        let initiallySelectedRadio = option.querySelector('input[type="radio"]:checked');
        option.querySelectorAll('input[type="radio"]').forEach(radio => {
          radio.addEventListener('change', (event) => {
            if (radio.dataset.sizeImage) {
              const selectionContainer = radio.closest('.product-selector-box');
              const selectionImg = selectionContainer.querySelector('.selection-img');
              const headingImg = selectionContainer.querySelector('.heading-img');
              if (selectionImg) {
                selectionImg.src = radio.dataset.sizeImage;
                selectionImg.dataset.src = radio.dataset.sizeImage;
                selectionImg.dataset.srcset = radio.dataset.sizeImage;
                selectionImg.classList.add('lazyload');
              }
              if (headingImg) {
                headingImg.src = radio.dataset.sizeImage;
              }
            }
            this.handleDropdownChange(this.dropdownAddons);
            const productSlider = document.querySelector(selectors.productSlider);
            if (productSlider) {
              const altText = radio.value;
              const slideIndex = findImageIndexByAlt(productSlider, selectors.sliderImage, altText);
            
              if (slideIndex !== -1) {
                selectCellWhenReady(productSlider, slideIndex);
              }
            }
          }); 
        });
        if(initiallySelectedRadio){
          initiallySelectedRadio.dispatchEvent(new Event('change'));
        }
      });

      function findImageIndexByAlt(container, imageSelector, altText) {
        const images = Array.from(container.querySelectorAll(imageSelector));
        return images.findIndex(img => img.alt.includes(altText));
      }
      
      function selectCellWhenReady(slider, index) {
        if (typeof slider.selectCell === 'function') {
          slider.selectCell(index);
        } else {
          const observer = new MutationObserver((mutations, obs) => {
            if (typeof slider.selectCell === 'function') {
              slider.selectCell(index);
              obs.disconnect();
            }
          });
      
          observer.observe(slider, {
            attributes: true,
            childList: true,
            subtree: true
          });
        }
      }

      // Add event listener for dropdown addons change
      this.dropdownAddons.forEach(dropdown => {
        dropdown.addEventListener('change', (event) => {
          this.handleDropdownChange(this.dropdownAddons, event);
        });
      });

      this.fabricFilters.forEach(filter => {
        this.initAccordion(filter);
      });

      this.filterByPatternDropdown.addEventListener('change', () => {
        this.handleFilterButtons();
      });

      // Add event listener for filter button click
      this.filterBtns.forEach(button => {
        const handleFilterClick = () => {
          const filterParent = button.closest('.fabric-filter-option');
          const filterSelection = filterParent.querySelector('.panel-selection');
          const selectedFilterLabel = button.dataset.filterLabel;
          const filterType = filterParent.dataset.filterType;

          if (filterSelection.innerText === selectedFilterLabel) {
            button.classList.remove('active');
            filterSelection.innerText = `Select fabric ${filterType}`;
          } else {
            filterParent.querySelectorAll('.filter-btn').forEach(btn => {
              btn.classList.remove('active');
            });
            button.classList.add('active');
            filterSelection.innerText = selectedFilterLabel;
          }
          
          this.handleFilterButtons();
        };

        button.addEventListener('click', handleFilterClick);
        button.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleFilterClick();
          }
        });
      });

      if (this.applyFilterBtn) {
        const handleApplyFilter = () => {
          if(!this.applyFilterBtn.classList.contains('active')){
            return;
          }
          let fabricFilterModal = document.getElementById("fabricFilterModal");
          this.filterFabricProducts();
          if(window.innerWidth < 640 && fabricFilterModal && fabricFilterModal.classList.contains("active")){
            fabricFilterModal.click();
          }
          if (this.fabricFilterAccordion) {
            this.fabricFilterAccordion.click();
          }
          setTimeout(() => {
            if (this.fabricContainer ) {
              this.fabricContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 500);
        };

        this.applyFilterBtn.addEventListener('click', handleApplyFilter);
        this.applyFilterBtn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleApplyFilter();
          }
        });
      }

      if(this.clearFilterBtn){
        const handleClearFilter = () => {
          if(!this.clearFilterBtn.classList.contains('active')){
            return;
          }
          let fabricFilterModal = document.getElementById("fabricFilterModal");
          this.fabricFilters.forEach(filter => {
            filter.querySelectorAll('.filter-btn').forEach(btn => {
              btn.classList.remove('active');
            });
          });
          this.filterByPatternDropdown.value = 'all';
          this.applyFilterBtn.classList.remove("active");
          this.clearFilterBtn.classList.remove("active");
          this.applyFilterBtn.innerText = 'Apply Filters';
          this.filterFabricProducts();
          if(window.innerWidth < 640 && fabricFilterModal && fabricFilterModal.classList.contains("active")){
            fabricFilterModal.click();
          }
          let dropdownDefault = document.querySelector('.nice-select.nice-2-dropdown li[data-value="all"]');
          if(dropdownDefault){
            dropdownDefault.click();
            dropdownDefault.closest('.open')?.classList.remove('open');
            const dropdownContainer =  dropdownDefault.closest('.box-content');
            if(dropdownContainer){
              dropdownContainer.style.overflow = 'hidden';
            }
          }
        };

        this.clearFilterBtn.addEventListener('click', handleClearFilter);
        this.clearFilterBtn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClearFilter();
          }
        });
      }

      this.drawerCloseBtn.forEach(closeEl => {
        closeEl.addEventListener('click', () => {
          const drawerModal = closeEl.closest('.fabric-filter-modal');
          if(drawerModal.classList.contains("active")){
            drawerModal.click();
          }
        });
      });
      // Add event listener for fabric products
      this.fabricProducts.forEach(product => {
        const handleFabricSelect = () => {
          this.handleProductSelection(product, this.fabricProducts);
          this.fabricMaterialModal = document.querySelector(selectors.fabricMaterialModal);
          if(this.fabricMaterialModal){
            this.updateFabricMaterialPopups(this.fabricMaterialModal,product);
          }
        };
        product.addEventListener('click', (e) => {
          if (e.target.closest('modal-opener') || e.target.closest('.product-popup-modal__button') || e.target.closest('.fabric-back-order-badge')) return;
          handleFabricSelect();
        });
        product.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (e.target.closest('modal-opener') || e.target.closest('.product-popup-modal__button') || e.target.closest('.fabric-back-order-badge')) return;
            e.preventDefault();
            handleFabricSelect();
          }
        });

        const backOrderBadge = product.querySelector('.fabric-back-order-badge');
        if (backOrderBadge) {
          backOrderBadge.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            // Desktop expands on hover only (CSS); tap-to-expand is for mobile/touch only.
            if (window.innerWidth > 800) return;
            const isExpanded = backOrderBadge.classList.contains('is-expanded');
            document.querySelectorAll('.fabric-back-order-badge.is-expanded').forEach(badge => {
              if (badge !== backOrderBadge) badge.classList.remove('is-expanded');
            });
            backOrderBadge.classList.toggle('is-expanded', !isExpanded);
          });
        }

        product.addEventListener('mouseover', () => {
          document.querySelector('.flyout-hover-swatch')?.remove();
          if (window.innerWidth > 800) {
            const hoverDiv = document.createElement('div');
            hoverDiv.classList.add('flyout-hover-swatch');
            const builderWrapper = document.querySelector('.builder-wrapper');
            const builderWrapperRect = builderWrapper.getBoundingClientRect();
            const hoverDivLeft = builderWrapperRect.left - 400;
            hoverDiv.style.left = `${hoverDivLeft}px`;
            product.appendChild(hoverDiv);
            this.updateFabricMaterialPopups(hoverDiv,product);
          }
        });
      
        product.addEventListener('mouseout', () => {
          const hoverDiv = product.querySelector('.flyout-hover-swatch');
          if (hoverDiv) {
            hoverDiv.remove();
          }
        });

      });

      if (!window.__fabricBackOrderBadgeOutsideClickBound) {
        window.__fabricBackOrderBadgeOutsideClickBound = true;
        document.addEventListener('click', (e) => {
          if (e.target.closest('.fabric-back-order-badge')) return;
          document.querySelectorAll('.fabric-back-order-badge.is-expanded').forEach(badge => {
            badge.classList.remove('is-expanded');
          });
        });
      }

      // Add event listener for firmness product selection
      this.firmnessProducts.forEach(product => {
        product.addEventListener('click', () => {
          this.handleProductSelection(product, this.firmnessProducts);
        });
        product.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleProductSelection(product, this.firmnessProducts);
          }
        });
      });

      // Add event listener for cushion type selection
      this.cushionTypes.forEach(product => {
        product.addEventListener('click', () => {
          this.handleProductSelection(product, this.cushionTypes);
        });
        product.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleProductSelection(product, this.cushionTypes);
          }
        });
      });

      // Add event listener for leg product selection
      this.legProducts.forEach(product => {
        product.addEventListener('click', () => {
          this.handleProductSelection(product, this.legProducts);
        });
        product.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleProductSelection(product, this.legProducts);
          }
        });
      });

      //Fix height after image loads
      this.selectImages.forEach(img => {
        img.onload = () => {
          const parentContainer = img.closest('.product-selector-box');
          if(parentContainer && parentContainer.classList.contains('active')){
            img.parentElement.style.maxHeight = `${img.parentElement.scrollHeight}px`;
          }
        };
      });

      //Event listener for window resize
      window.addEventListener('resize', () => {
        this.productSelectors.forEach(accordion => {
          const boxContent = accordion.querySelector('.box-content');
          if (accordion.classList.contains('active')) {
            boxContent.style.maxHeight = boxContent.scrollHeight + 'px';
          }
        });
      });

      this.selectAll('.nice-select.option-select').forEach(niceDropdown => {
        niceDropdown.addEventListener('click', () => {
         niceDropdown.closest('.box-content').style.overflow = 'visible';
         const fabricFilterOptions = niceDropdown.closest('#fabric-filter-options');
         if(fabricFilterOptions){
          fabricFilterOptions.style.overflow = 'visible';
         }
        });
      });

      this.initFabricFilterModal();

      // Read reviews scroll handlers (Okendo) - support multiple triggers
      var reviewTriggers = document.querySelectorAll('.read-reviews-container, .star-rating-container');
      if (reviewTriggers && reviewTriggers.length) {
        reviewTriggers.forEach(function(trigger){
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            var target = document.querySelector('[data-oke-widget]') ||
                         document.querySelector('.okeReviews, .oke-widget, .okeReviews-widget');
            if (target) {
              var y = target.getBoundingClientRect().top + window.pageYOffset - 100;
              window.scrollTo({ top: y, behavior: 'smooth' });
            }
          });
        });
      }
    }, 

    initAccordion: function(accordion, allHeadings){
      const selectorHeading = accordion.querySelector('.box-heading');
      if (selectorHeading) {
        const toggleAccordion = (e) => {
          e.stopPropagation();
          if(!e.target.classList.contains('panel-popup') && e.target.closest('.panel-popup')){
            return;
          }
          const isActive = selectorHeading.parentElement.classList.contains('active');

          selectorHeading.parentElement.classList.toggle('active', !isActive);
          selectorHeading.setAttribute('aria-expanded', String(!isActive));

          const boxContent = selectorHeading.parentElement.querySelector('.box-content');
          if(boxContent){
            boxContent.style.maxHeight = isActive ? '0' : boxContent.scrollHeight + 'px';
            boxContent.style.overflow = 'hidden';
            boxContent.inert = isActive;
          }

          const parentContainer = accordion.closest('.box-content');
          if(parentContainer && boxContent){
            parentContainer.style.maxHeight =  parentContainer.scrollHeight + boxContent.scrollHeight + 'px';
          }
          this.closeAllSelect();

          selectorHeading.parentElement.querySelectorAll('.nice-select').forEach(function(selector) {
            selector.classList.remove('open');
          })
        };

        selectorHeading.addEventListener('click', toggleAccordion);

        selectorHeading.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (e.target.closest('.panel-popup')) return;
            e.preventDefault();
            toggleAccordion(e);
          }
        });
      }
    },

    /* Custom Select Dropdown W3 */
    initCustomSelectDropdowns: function(){
      var x, i, j, l, ll, selElmnt, a, b, c;
      x = this.dropdownContainers;
      l = this.dropdownContainers.length;
      var self = this;
      for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        /* For each element, create a new DIV that will act as the selected item: */
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.setAttribute("tabindex", "0");
        a.setAttribute("role", "combobox");
        a.setAttribute("aria-expanded", "false");
        a.setAttribute("aria-haspopup", "listbox");
        a.innerHTML = this.formatOptionText(selElmnt.options[selElmnt.selectedIndex].innerHTML);
        x[i].appendChild(a);
        /* For each element, create a new DIV that will contain the option list: */
        b = document.createElement("DIV");
        var placeHolder = document.createElement("DIV");
        placeHolder.setAttribute("class", "select-placeholder");
        placeHolder.innerHTML = 'Select ' + x[i].dataset.addonType;
        b.appendChild(placeHolder);
        b.setAttribute("class", "select-items select-hide");
        b.setAttribute("role", "listbox");
        for (j = 1; j < ll; j++) {
          /* For each option in the original select element,
          create a new DIV that will act as an option item: */
          c = document.createElement("DIV");
          c.setAttribute("role", "option");
          c.innerHTML = selElmnt.options[j].innerHTML;
          c.addEventListener("click", function(e) {
            /* When an item is clicked, update the original select box,
            and the selected item: */
            var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sl; i++) {
              if (s.options[i].innerHTML == this.innerHTML) {
                s.selectedIndex = i;
                h.innerHTML = self.formatOptionText(this.innerHTML);
                y = this.parentNode.getElementsByClassName("same-as-selected");
                yl = y.length;
                for (k = 0; k < yl; k++) {
                  y[k].removeAttribute("class");
                }
                this.setAttribute("class", "same-as-selected");
                s.dispatchEvent(new Event('change'));
                break;
              }
            }
            h.click();    
          });
          b.appendChild(c);
          // Check if the current option is selected and add the class "same-as-selected"
          if (selElmnt.options[j].selected) {
            c.setAttribute("class", "same-as-selected");
          }
        }
        x[i].appendChild(b);
        // Add "same-as-selected" class to initially selected element
        var initiallySelectedOption = selElmnt.options[selElmnt.selectedIndex];
        var initiallySelectedDiv = b.querySelector('div:nth-child(' + (selElmnt.selectedIndex + 1) + ')');
        initiallySelectedDiv.setAttribute("class", "same-as-selected");
        a.addEventListener("click", function(e) {
          /* When the select box is clicked, close any other select boxes,
          and open/close the current select box: */
          e.stopPropagation();
          self.closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
          var isOpen = !this.nextSibling.classList.contains("select-hide");
          this.setAttribute("aria-expanded", String(isOpen));
          const parentContainer = a.closest('.box-content');
          if (parentContainer) {
            parentContainer.style.maxHeight = parentContainer.scrollHeight + 'px';
            parentContainer.style.overflow = 'visible';
          }
        });
        a.addEventListener("keydown", function(e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.click();
          } else if (e.key === "Escape") {
            var listbox = this.nextSibling;
            if (!listbox.classList.contains("select-hide")) {
              listbox.classList.add("select-hide");
              this.classList.remove("select-arrow-active");
              this.setAttribute("aria-expanded", "false");
            }
          } else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault();
            var listbox = this.nextSibling;
            if (listbox.classList.contains("select-hide")) {
              this.click();
            }
            var options = listbox.querySelectorAll("[role='option']");
            if (options.length) {
              var currentIdx = Array.from(options).findIndex(function(o) { return o.classList.contains("same-as-selected"); });
              var nextIdx = e.key === "ArrowDown" ? Math.min(currentIdx + 1, options.length - 1) : Math.max(currentIdx - 1, 0);
              options[nextIdx].click();
            }
          }
        });
      }
    },

    initNice2Dropdowns: function(){
      var options = {searchable: true};
      this.nice2Dropdowns.forEach(element => {
        NiceSelect.bind(element, options);
        element.setAttribute('tabindex', '-1');
        var scrollbar = element.parentElement && element.parentElement.querySelector('custom-scrollbar');
        if (scrollbar) scrollbar.setAttribute('tabindex', '-1');
      });
      setTimeout(() => {
        document.querySelectorAll('.nice-select-dropdown li').forEach(el => {
          let elementText = el.innerText;
          if(elementText.includes('(Popular)')){
            el.innerHTML = elementText.replace('(Popular)', '<span class="popular">(Popular)</span>');
          }
      }, 1000)});
    },
  

    initFabricFilterModal: function () {
      var fabricFilterModal = document.getElementById("fabricFilterModal");
      var fabricFilterMobileBtn = document.getElementById("fabric-accordion-btn"); // Button to open the modal
      
      const modalContent = document.getElementById('fabric-filter-modal-content');

      var filterHeadingEl = fabricFilterMobileBtn.closest('.filter-heading');
      var handleFilterOpen = function() {
        if(window.innerWidth < 640){
          let originalContent = document.getElementById('fabric-filter-options');
          originalContent.style.maxHeight = "unset"
          modalContent.appendChild(originalContent);
          modalContent.querySelectorAll('.fabric-filter-option').forEach(function(element){
            element.classList.remove('active');
            let boxContent = element.querySelector('.box-content');
            if(boxContent){
              boxContent.style.maxHeight = '0';
            }
          });
          fabricFilterModal.classList.add('active');
        }
      };
      fabricFilterMobileBtn.onclick = handleFilterOpen;
      if (filterHeadingEl) {
        filterHeadingEl.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleFilterOpen();
          }
        });
      }

      // Optional: Close modal if user clicks outside of it
      window.addEventListener("click", function(event) {
        if (event.target == fabricFilterModal) {
          originalContent = document.getElementById('fabric-filter-options');
          originalContent.querySelectorAll('.fabric-filter-option').forEach(function(element){
            element.classList.remove('active');
            let boxContent = element.querySelector('.box-content');
            if(boxContent){
              boxContent.style.maxHeight = '0';
              boxContent.style.overflow = 'hidden';
            }
          });
          document.querySelector('.fabric-filter_container').appendChild(originalContent);
          fabricFilterModal.classList.remove('active');
        }
      });
    },

    formatOptionText: function(text) {
      var title = text.replace(/\(.+?\)/g, '').trim();
      var price = text.match(/\(.+?\)/g);
      var formattedText = '<span class="title">' + title + '</span>';
      if (price) {
        formattedText += ' <span class="price">' + price.join(' ') + '</span>';
      }
      return formattedText;
    },

    closeAllSelect: function (elmnt) {
      /* A function that will close all select boxes in the document,
      except the current select box: */
      var x, y, i, xl, yl, arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i)
        } else {
          y[i].classList.remove("select-arrow-active");
          y[i].setAttribute("aria-expanded", "false");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      } 
    },

    filterAndDisplayProducts: function(fabricProducts, fabricContainer, selectedColor, selectedType, selectedPattern) {
      let preferredSizeAvailable = false;
      fabricProducts.forEach(product => {
        if (product.dataset.productSize === fabricContainer.dataset.selectedSize) {
          preferredSizeAvailable = true;
        }
      });

      let noProductsFound = true;
      let firstFilteredProduct = null;

      fabricProducts.forEach(product => {
        const productSize = product.dataset.productSize;
        const showSize = !productSize ||
          (preferredSizeAvailable && productSize === fabricContainer.dataset.selectedSize) ||
          (!preferredSizeAvailable && ((fabricContainer.dataset.selectedSize === "Large" && productSize === "Medium") ||
                                       (fabricContainer.dataset.selectedSize === "Medium" && productSize === "Small")));
    
        if (showSize) {
          const conditions = [
            selectedColor && !product.classList.contains(selectedColor),
            selectedType && !product.classList.contains(selectedType),
            selectedPattern && !product.classList.contains(selectedPattern),
          ];
    
          const showProduct = !conditions.some(condition => condition);
    
          product.style.display = showProduct ? 'flex' : 'none';
    
          if (showProduct && !firstFilteredProduct) {
            firstFilteredProduct = product;
            noProductsFound = false;
          }
        } else {
          product.style.display = 'none';
        }
      });
    
      return { noProductsFound, firstFilteredProduct };
    },

    filterFabricProducts: function(){
      const selectedColorButton = this.select('.color-filters .filter-btn.active');
      const selectedTypeButton = this.select('.type-filters .filter-btn.active');
      const selectedPatternDropdown = this.select('#filter-pattern-select');
      const fabricContainer = document.querySelector('[data-selected-size]');
    
      const selectedColor = selectedColorButton ? 'color_' + selectedColorButton.dataset.filter : '';
      const selectedType = selectedTypeButton ? 'type_' + selectedTypeButton.dataset.filter : '';
      let selectedPattern = selectedPatternDropdown ? 'pattern_' + selectedPatternDropdown.value : '';
      if (selectedPattern == "pattern_all") {
        selectedPattern = 'fabric_product';
      }
      const result = this.filterAndDisplayProducts(
        this.fabricProducts,
        fabricContainer,
        selectedColor,
        selectedType,
        selectedPattern,
      );
    
      if (this.fabricContainer) {
        this.fabricContainer.style.maxHeight = this.fabricContainer.scrollHeight + 'px';
        if (result.noProductsFound) {
          this.fabricContainer.classList.add('no-products');
          const addon = this.fabricContainer.querySelector('.enavi_addon.active');
          if (addon) {
            addon.classList.remove('active');
          }
          this.fabricContainer.closest('.product-selector-box').querySelector('.panel-selection').innerText = 'Choose Your Fabric';
        } else {
          this.fabricContainer.classList.remove('no-products');
        }
      }

      // Update the filters count
      let activeFiltersCount = 0;
      if (selectedColorButton) activeFiltersCount++;
      if (selectedTypeButton) activeFiltersCount++;
      if (selectedPatternDropdown?.value !== "all") {
        activeFiltersCount++;
      }
      const filtersNumberElement = document.querySelector('#filters-number');
      if (filtersNumberElement) {
        filtersNumberElement.textContent = activeFiltersCount > 0 ? `(${activeFiltersCount})` : '';
        filtersNumberElement.setAttribute('data-filters-set', activeFiltersCount);
      }

      if (result.firstFilteredProduct) {
        result.firstFilteredProduct.click();
      }
    },

    handleFilterButtons: function() {
      const selectedColorButton = this.select('.color-filters .filter-btn.active');
      const selectedTypeButton = this.select('.type-filters .filter-btn.active');
      const selectedPatternDropdown = this.select('#filter-pattern-select');
      const currentFiltersApplied = document.querySelector('#filters-number').dataset.filtersSet;
      const fabricContainer = document.querySelector('[data-selected-size]');

      const selectedColor = selectedColorButton ? 'color_' + selectedColorButton.dataset.filter : '';
      const selectedType = selectedTypeButton ? 'type_' + selectedTypeButton.dataset.filter : '';
      let selectedPattern = selectedPatternDropdown ? 'pattern_' + selectedPatternDropdown.value : 'pattern_all';
      if (selectedPattern == "pattern_all") {
        selectedPattern = 'fabric_product';
      }
      let preferredSizeAvailable = false;
      this.fabricProducts.forEach(product => {
        if (product.dataset.productSize === fabricContainer.dataset.selectedSize) {
          preferredSizeAvailable = true;
        }
      });
    
      const filteredProductCount = this.fabricProducts.filter(product => {
        const productSize = product.dataset.productSize;
        const showSize = !productSize || 
                        (preferredSizeAvailable && productSize === fabricContainer.dataset.selectedSize) || 
                        (!preferredSizeAvailable && ((fabricContainer.dataset.selectedSize === "Large" && productSize === "Medium") || 
                                                     (fabricContainer.dataset.selectedSize === "Medium" && productSize === "Small")));
    
        if (!showSize) return false;
    
        const conditions = [
            selectedColor && !product.classList.contains(selectedColor),
            selectedType && !product.classList.contains(selectedType),
            selectedPattern && !product.classList.contains(selectedPattern),
        ];
    
        return !conditions.some(condition => condition);
    }).length;

      let filterButtonText = 'Apply Filters';
      if(filteredProductCount > 0){
        if(selectedColorButton || selectedTypeButton || selectedPatternDropdown.value != 'all'){
          filterButtonText = `Show ${filteredProductCount} Fabrics`;
        }
      }
      this.applyFilterBtn.innerText = filterButtonText;

      if(currentFiltersApplied && currentFiltersApplied > 0){
        this.applyFilterBtn.classList.add("active");
        this.clearFilterBtn.classList.add("active");
      }else{
        if( selectedColor != '' || selectedType != '' || selectedPattern != 'fabric_product' && filteredProductCount > 0){
          this.applyFilterBtn.classList.add("active");
          this.clearFilterBtn.classList.add("active");
        }else{
          this.applyFilterBtn.classList.remove("active");
          this.clearFilterBtn.classList.remove("active");
        }
      }
    },

    handleDropdownChange: function(selectors, event) {
      const selectedOptions = [];
      const selectedSizes = [];
      const productSelectorEl = selectors[0].closest('.product-selector-box');
      const panelLabel = productSelectorEl.querySelector('.panel-selection');
      const selectionLabel = productSelectorEl.querySelector('.selection-label');
      const fabricContainer = document.querySelector('[data-selected-size]');
      const cushionContainer = document.querySelector('[data-cushion-container]');
      const product = JSON.parse(document.querySelector('#product-json').innerHTML);

      const selectedColorButton = this.select('.color-filters .filter-btn.active');
      const selectedTypeButton = this.select('.type-filters .filter-btn.active');
      const selectedPatternDropdown = this.select('#filter-pattern-select');
    
      const selectedColor = selectedColorButton ? 'color_' + selectedColorButton.dataset.filter : '';
      const selectedType = selectedTypeButton ? 'type_' + selectedTypeButton.dataset.filter : '';
      let selectedPattern = selectedPatternDropdown ? 'pattern_' + selectedPatternDropdown.value : '';
      if (selectedPattern == "pattern_all") {
        selectedPattern = 'fabric_product';
      }
      // Get selected radio options
      const radioSelectors = Array.from(productSelectorEl.querySelectorAll('input[type="radio"]:checked'));
      radioSelectors.forEach(radioSelector => {
        selectedOptions.push({ radioOption: true, productName: radioSelector.name, variantTitle: radioSelector.value });
        if (radioSelector.name === 'Corner') {
          if (!radioSelector.value.includes('Left') && !radioSelector.value.includes('Right')) {
            return;
          }
          const selectedFeature = 'ORIENTATION';
          const selectedValue = radioSelector.value.split(' ').pop();
          this.updateCylindoViewer(selectedFeature, selectedValue);
        }
      });



      // Get selected dropdown options
      selectors.forEach(selector => {
        const selectedOption = selector.options[selector.selectedIndex];
        const productName = selector.dataset.fieldName;
        const variantId = selectedOption.dataset.variantId;
        const value = selectedOption.value;
        selectedOptions.push({ id: variantId, productName, variantTitle: value });
        selectedSizes.push({ id: variantId, productName, variantTitle: value });
      });

      function findSizes(selectedSizes, productMetafields) {
        return selectedSizes.map(selectedSize => {
          const variantTitle = selectedSize.variantTitle;
          const sizeObject = productMetafields.sizes.find(sizeObj => 
            sizeObj.options.includes(variantTitle)
          );
          return sizeObject ? sizeObject.size : null;
        });
      }
      
      function determineFinalSize(sizes) {
        const sizeHierarchy = ["Small", "Medium", "Large"];
        
        const allSame = sizes.every(size => size === sizes[0]);
        if (allSame) {
          return sizes[0];
        }
      
        let largestSize = sizes[0];
        sizes.forEach(size => {
          if (sizeHierarchy.indexOf(size) > sizeHierarchy.indexOf(largestSize)) {
            largestSize = size;
          }
        });
      
        return largestSize;
      }
      
      // Get the sizes for the selected variants
      const sizes = findSizes(selectedSizes, product.metafields);
      const finalSize = determineFinalSize(sizes);

      fabricContainer.setAttribute('data-selected-size', finalSize)
      
      let preferredCushionSizeAvailable = false;
      let activeClassAdded = false;

      if (cushionContainer) {
        this.cushionTypes.forEach(product => {
          product.classList.remove('active');
          if (product.dataset.productSize === finalSize) {
            preferredCushionSizeAvailable = true;
          }
        });
  
        this.cushionTypes.forEach(product => {
          const productSize = product.dataset.productSize;
          const selectionContainer = product.closest('.product-selector-box');
          const selectionLabel = selectionContainer.querySelector('.panel-selection');
          const showSize = !productSize || 
                          (preferredCushionSizeAvailable && productSize === finalSize) || 
                          (!preferredCushionSizeAvailable && ((finalSize === "Large" && productSize === "Medium") || 
                                                              (finalSize === "Medium" && productSize === "Small")));
  
          product.style.display = showSize ? 'flex' : 'none';
          if (showSize && !activeClassAdded) {
            product.classList.add('active');
            selectionLabel.innerText = product.dataset.productLabel;
            activeClassAdded = true;
          }
          if (event?.target.id && event?.target.id.includes('size-select') && cushionContainer.classList.contains('active')) {
            cushionContainer.style.maxHeight = cushionContainer.scrollHeight + 'px';
          }
        });
      }

      const result = this.filterAndDisplayProducts(
        this.fabricProducts,
        fabricContainer,
        selectedColor,
        selectedType,
        selectedPattern,
      );
      

      // Generate string output for selectionLabel
      const selectedOptionsString = selectedOptions.map(option => {
        let title = option.variantTitle.toLowerCase().replace("sofa", "").replace(" inches", "\"").trim();

        if (title) {
          // Capitalize each word
          title = title.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

          if (option.radioOption) {
            return title;
          } else {
            let name = option.productName.toLowerCase().replace("sofa", "").trim();
            if (name) {
              // Capitalize each word in the name
              name = name.replace("*", "").split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
              return `${name}: ${title}`;
            }
          }
        }
        return '';
      }).filter(option => option).join(', ');

      // Set the generated string as the innerText of selectionLabel and panelLabel
      selectionLabel.innerText = selectedOptionsString;
      panelLabel.innerText = selectedOptionsString;

      this.evaluateTotalPrice();

    },

    updateCylindoViewer: function(addonType, selectedOption) {
      if (this.cylindoViewer) {
        // Remove any existing error message
        const existingError = document.querySelector('.cylindo-error-message');
        if (existingError) {
          existingError.remove();
        }
    
        this.cylindoViewer.features = {
          ...this.cylindoViewer.features,
          [addonType.toLowerCase()]: selectedOption
        };
      }
    },

    handleProductSelection: function (el, allProducts) {
      const selectionContainer = el.closest('.product-selector-box');
      const boxContent = selectionContainer.querySelector('.box-content');
      const panelLabel = selectionContainer.querySelector('.panel-selection');
      const selectionLabel = selectionContainer.querySelector('.selection-label');
      const selectionDesc = selectionContainer.querySelector('.selection-desc');
      const selectionImg = selectionContainer.querySelector('.selection-img');
      const headingImg = selectionContainer.querySelector('.heading-img');
      const addonType = selectionContainer.dataset.selectorType;
      const viewer = document.querySelector("cylindo-viewer");
      // Add Cylindo viewer update for fabric and legs
      console.log(addonType);
      if (addonType === 'Fabric') { 
        const selectedFeature = 'UPHOLSTERY';
        const selectedValue = el.dataset.cylindoValue || el.dataset.productLabel;
        this.updateCylindoViewer(selectedFeature, selectedValue);
      }

      if (addonType === 'Legs') { 
        const selectedFeature = 'LEG TYPE';
        const selectedValue = el.dataset.cylindoValue || el.dataset.productLabel;
        this.updateCylindoViewer(selectedFeature, selectedValue);
      }


      panelLabel.innerText = el.dataset.productLabel;
      if(selectionLabel){
        selectionLabel.innerText = el.dataset.productLabel;
      }
      
      if (selectionImg && el.dataset.productImage) {
        selectionImg.onload = () => {
          boxContent.style.maxHeight = `${boxContent.scrollHeight}px`;
        };
        selectionImg.src = el.dataset.productImage;
      }

      if (headingImg && el.dataset.productImage) {
        headingImg.src = el.dataset.productImage;
        if (headingImg.srcset) {
          headingImg.srcset = el.dataset.productImage;
        }
      }

      if (selectionDesc && el.dataset.productDesc) {
        selectionDesc.innerHTML = el.dataset.productDesc;
      }else if(selectionDesc){
        selectionDesc.innerHTML = '';
      }

      if(selectionContainer.classList.contains('enavi_option_error')){
        selectionContainer.classList.remove('enavi_option_error');
      }

      boxContent.style.maxHeight = `${boxContent.scrollHeight}px`;

      allProducts.forEach((product) => {
        product.classList.remove('active');
      });
      el.classList.add('active');

      this.evaluateTotalPrice();
    },

    handleAtc: function(){
      if(this.postDisabled){
        return;
      }
      this.postDisabled = true;
 
      this.prepareAndPostFormData();
    },


    prepareAndPostFormData: async function(){
      this.allItems = await this.getAllItems();
      
      if(!this.checkIfRequiredAddonSelected(this.allItems)){
        this.postDisabled = false;
        return;
      }

      this.emitSubmitEvent();
     // this.addAlltemsToCart();
    },

    getAllItems: function(){
      const addonLineProps = this.selectAll('.addon-line-item-prop');

      addonLineProps.forEach(el => {
        el.remove();
      });

      const addonItems = this.getAddonItems();
      if(addonItems.length > 0){
        this.addParentLineItemProperties(addonItems);
      }
      return addonItems;
    },

    emitSubmitEvent: function(){     
      setTimeout((function(){
        this.addToCart.disabled = false;
        this.addToCart.setAttribute("data-disable-atc", "false");
        this.addToCart.type = 'submit';
        this.addToCart.click();
        this.addToCart.setAttribute('data-disable-atc','true');
        this.addToCart.type = 'button';
        this.postDisabled = false;
      }).bind(this),100);
    },
    
    addAlltemsToCart: function(){
      // Filter out items that are not actual products
      const filteredItems = this.allItems.filter(item => item.id !== undefined);
    
      const data = { items: filteredItems };
      const self = this;
    
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            self.emitSubmitEvent();
          } else {
            alert("An error occurred while adding items to cart: " + xhr.status);
            self.postDisabled = false;
          }
        }
      };
      xhr.send(JSON.stringify(data));
      this.allItems = [];
    },

    addParentLineItemProperties: function(addonItems){

      var lineItemProps = { 
        _addon_products: []
      };
      addonItems.forEach(item => { 
        lineItemProps[item.addon_type] = item.title;
        if(item.id){
          let _variant = `${item.id}${isNaN(Number(item.price)) ? '_0' : `_${item.price}`}`;

          lineItemProps['_addon_products'].push(_variant);
        }
        if (item.parentLineItem == "true"){
          Object.entries(item.properties).map((function(property){
            if (!property[0].startsWith('_')){
              lineItemProps[property[0]] = property[1];
              delete item.properties[property[0]];
            }
          }))   
        }
      });

      for (let propName in lineItemProps) {
        const propNode = document.querySelector('[name="properties[' + propName + ']"]');
        if (propNode) {
            propNode.value = lineItemProps[propName];
        } else {
            const input = document.createElement("input");
            input.type = "hidden";
            input.className = "addon-line-item-prop";
            input.name = "properties[" + propName + "]";
            input.value = lineItemProps[propName];
            this.form.appendChild(input);
        }
      }
    },

    getAddonItems: function() {
      var addonItems = [];
    
      var selectedAddons = Array.from(this.container.querySelectorAll('.enavi_addon.active'))
        .map(item => {
          return {
            id: item.dataset.variantId,
            quantity: 1,
            price: item.dataset.productPrice ?? '0',
            title: item.dataset.productLabel,
            addon_type: item.parentElement.dataset.addonType,
            properties: {'_addon_product': true, '_general_product_id': this.container.dataset.mainProductId, '_properties_value': item.dataset.productLabel},
            parentLineItem: item.hasAttribute('data-parent-line') ? 'true' : undefined
          };
        });
    
      var dropdownAddons = Array.from(this.container.querySelectorAll('.enavi-selector_addon')).map((item) => {
        var selectedOption = item.options[item.selectedIndex];
        return {
          id: selectedOption.dataset.variantId,
          quantity: 1,
          price: selectedOption.dataset.productPrice ?? '0',
          title: item.value,
          addon_type: item.parentElement.dataset.addonType,
          properties: {'_addon_product': true, '_general_product_id': this.container.dataset.mainProductId, '_properties_value': item.value},
          parentLineItem: selectedOption.hasAttribute('data-parent-line') ? 'true' : undefined
        };
      });

      var radioAddons = Array.from(this.container.querySelectorAll('.radio-option')).map((item) => {
        var selectedOption = item.querySelector('input[type="radio"]:checked');
        return {
          id: selectedOption.dataset.variantId,
          quantity: 1,
          title: selectedOption.value,
          addon_type: selectedOption.name,
          properties: {'_addon_product': true, '_general_product_id': this.container.dataset.mainProductId, '_properties_value': selectedOption.value},
          parentLineItem: selectedOption.hasAttribute('data-parent-line') ? 'true' : undefined
        };
      });

      addonItems = radioAddons.concat(dropdownAddons).concat(selectedAddons);

      return addonItems;
    },

    getAddonLineItemProperties: function (item) {
      var properties = {};
      this.selectAll('.addon_property[data-variant-id="'+item.value +'"]').forEach(function (propertyNode) {
          if((propertyNode.type === "text" && propertyNode.value) || propertyNode.checked === true){
            properties[propertyNode.name] = propertyNode.value;
          }
      });
      return properties;
    },

    evaluateTotalPrice: function() {
      const addonElements = Array.from(document.querySelectorAll('.enavi_addon.active'));
      const selectorElements = Array.from(document.querySelectorAll('.enavi-selector_addon'));
    
      const addonPrices = addonElements.map(element => {
        const price = parseInt(element.getAttribute('data-product-price'));
        return isNaN(price) ? 0 : price;
      });
    
      const selectorPrices = selectorElements.map(element => {
        const selectedIndex = element.selectedIndex;
        const selectedOption = element.options[selectedIndex];
        const price = parseInt(selectedOption.getAttribute('data-product-price'));
        return isNaN(price) ? 0 : price;
      });
    
      const totalPrice = this.basePrice + addonPrices.reduce((a, b) => a + b, 0) + selectorPrices.reduce((a, b) => a + b, 0);
      let format = window.theme.settings.money_with_currency_format || "${{amount}}";
      var priceText =  formatMoney(totalPrice, format);
      this.atcPrice.innerText = priceText;
      this.productPriceEl.innerText = priceText;

      //Refresh Affirm UI
      try {
        document.querySelector('.affirm-as-low-as').setAttribute('data-amount',totalPrice);
        affirm.ui.refresh();
      } catch (error) {
        console.log('Affirm not found');
      }
    },

    checkIfRequiredAddonSelected: function(allItems){
      const emptyRequiredOptions = [];

      this.requiredAddons.forEach(addon => {
        if (addon.classList.contains('enavi-selector-addon')) {
          // For select elements with class 'enavi-selector-addon'
          const selectedOption = addon.querySelector('option:checked');
          if (!selectedOption) {
            emptyRequiredOptions.push(addon);
            addon.classList.add('enavi_option_error');
          } else {
            addon.classList.remove('enavi_option_error');
          }
        } else if (addon.classList.contains('product-selector-box')) {
          // For elements with class 'product-selector'
          const activeAddon = addon.querySelector('.enavi_addon.active');
          if (!activeAddon) {
            emptyRequiredOptions.push(addon);
            addon.classList.add('enavi_option_error');
          } else {
            addon.classList.remove('enavi_option_error');
          }
        }
      });

      if(emptyRequiredOptions.length){
        this.select('.enavi-error-message')?.classList.add('active');
      }else{
        this.select('.enavi-error-message')?.classList.remove('active');
      }
      return emptyRequiredOptions.length === 0;
    },

    updateFabricMaterialPopups: function(modal, product){
      modal.innerHTML = '';
      const img = document.createElement('img');
      img.classList.add('material-img');
      img.src = product.dataset.productImage;
      const materialLabel = document.createElement('div');
      materialLabel.classList.add('material-label');
      materialLabel.innerText = product.dataset.productLabel;

      // Add back order information if product is out of stock
      if (product.dataset.outOfStock === 'true' && product.dataset.backOrderDate) {
        const backOrderInfo = document.createElement('span');
        backOrderInfo.classList.add('fabric-back-order');
        backOrderInfo.innerText = 'Backorder until ' + product.dataset.backOrderDate;
        materialLabel.appendChild(backOrderInfo);
      }

      const materialDesc = document.createElement('div');
      materialDesc.classList.add('material-desc');
      materialDesc.innerHTML = `<p>${product.dataset.productDesc}</p>`;
      modal.appendChild(img);
      modal.appendChild(materialLabel);
      modal.appendChild(materialDesc);
      let modalContent = modal.closest('.product-popup-modal__content');
      if(modalContent && modalContent.querySelector('.product-popup-modal__content-header h4')){
        modalContent.querySelector('.product-popup-modal__content-header h4').innerText =  product.dataset.productLabel;
      }
    },

    handleCylindoDefaultFeatures: function() {
      if (!this.cylindoViewer) return;

      // Get default features from Cylindo viewer
      const defaultFeatures = this.cylindoViewer.features;
      console.log('Default Cylindo Features:', defaultFeatures);

      // Match features to sofa builder options
      if (defaultFeatures) {
        // Handle fabric selection
        if (defaultFeatures.upholstery) {
          const fabricName = defaultFeatures.upholstery.replace(/-/g, ' ');
          const fabricOption = this.fabricProducts.find(product => {
            const productLabel = product.dataset.productLabel?.toLowerCase();
            return productLabel && productLabel.includes(fabricName.toLowerCase());
          });
          if (fabricOption) {
            this.handleProductSelection(fabricOption, this.fabricProducts);
          }
        }

        // Handle leg selection
        if (defaultFeatures['leg type']) {
          const legName = defaultFeatures['leg type'].replace(/-/g, ' ');
          const legOption = this.legProducts.find(product => {
            const productLabel = product.dataset.productLabel?.toLowerCase();
            return productLabel && productLabel.includes(legName.toLowerCase());
          });
          if (legOption) {
            this.handleProductSelection(legOption, this.legProducts);
          }
        }

        // Handle orientation if present
        if (defaultFeatures.orientation) {
          const orientationRadio = this.container.querySelector(`input[type="radio"][value*="${defaultFeatures.orientation}"]`);
          if (orientationRadio) {
            orientationRadio.checked = true;
            orientationRadio.dispatchEvent(new Event('change'));
          }
        }
      }
    }

  });

  return EnaviSofaBuilder;
})();

new theme.EnaviSofaBuilder(document.querySelector('.product-information'));